export const showScheduleDemoModal = (toggle) => {
    window.localStorage.setItem("showRequestDemo", toggle);
    window.dispatchEvent(new Event("storage"));
};